/* eslint-disable import/extensions */
// Importing necessary libraries and components
import React from "react";
import IconButton from "@material-ui/core/IconButton";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Menu from "@material-ui/core/Menu";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import styles from "assets/jss/material-dashboard-react/components/businessForm";
import { sendMailAgain } from "actions/MerchantSignUp";
import { useSnackbar } from "notistack";
import AppLoader from "components/AppLoader/Index";
import { sendInviteApiCall } from "../../actions/Operations";
import { profileCodePermissionCheck } from "../../Utils/commonUtils";

import {
  sendInviteManagerApiCall,
  reSendInviteManagerApiCall,
} from "../../actions/Operations";

// Hook to apply custom styles
const useStyles = makeStyles(styles);

// MerchantSetupMenu component definition
function MerchantSetupMenu(props) {
  const classes = useStyles(); // Applying custom styles
  const [anchorEl, setAnchorEl] = React.useState(null); // State to manage menu anchor
  const [managerListData, setManagerListData] = React.useState(); // State to store manager list data
  const [filteredManager, setFilteredManager] = React.useState(null); // State to store filtered manager data
  const [loading, setLoading] = React.useState(false); // State to manage loading state
  const { enqueueSnackbar } = useSnackbar(); // Snackbar for notifications
  const menu = JSON.parse(localStorage.getItem("menu")); // Fetching menu data from localStorage
  const open = Boolean(anchorEl); // Boolean to check if the menu is open
  const profileCode = props.userDetails?.leftMenu?.data?.Profile_Code;
  const isVCSAdmin =
    profileCodePermissionCheck.profileCode.VCS === profileCode;
  const isPrimaryManager = filteredManager?.ManagerStatus?.First_Manager_Business === true;
  // Function to handle menu open
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    props.setValues((pre) => {
      pre.status = props.details.Current_Status;
      return pre;
    });
  };

  // Effect to fetch manager list data
  React.useEffect(() => {
    setManagerListData(
      props.mainData?.merchantInformation?.merchantListNames?.data
    );
  }, [props]);

  // Effect to filter manager data based on props.id
  React.useEffect(() => {
    if (managerListData && props.id) {
      const filteredData = managerListData.filter(
        (item) => item._id === props.id
      );
      const selectedManager = filteredData.length > 0 ? filteredData[0] : null;
      setFilteredManager(selectedManager);
    }
  }, [managerListData, props.id]);

  // Function to handle menu close
  const handleClose = (type) => {
    if (type === "edit") {
      props.history.push(
        `/${props.userDetails.layout}/MerchantDetails?id=${props.id}`
      );
    }
    setAnchorEl(null);
  };

  // Function to handle invite manager
  const handleInviteManager = () => {
    for (const item of managerListData) {
      if (item._id === props.id) {
        localStorage.setItem("businessName", item.Business_Name);
        localStorage.setItem("Manager_uid", item.Manager_Details.Manager_uid);
        localStorage.setItem("User_Id", item.User_Id);
        localStorage.setItem(
          "searchDataMerchant",
          JSON.stringify({
            searchBusinessName: props.merchantListData.searchBusinessName,
            searchDbaName: props.merchantListData.searchDbaName,
            searchManagerId: props.merchantListData.searchManagerId,
            searchStatus: props.merchantListData.searchStatus,
            searchManagerName: props.merchantListData.searchManagerName,
          })
        );
        props.history.push(
          `/${props.userDetails.layout}/ManagerList?id=${props.id}`
        );
      }
    }
  };

  // Function to handle invite manager
  const editServices = () => {
    setAnchorEl(null); // Close the menu

    for (const item of managerListData) {
      if (item._id === props.id) {
        localStorage.setItem("businessName", item.Business_Name);
        localStorage.setItem("Manager_uid", item.Manager_Details.Manager_uid);
        localStorage.setItem("User_Id", item.User_Id);
        localStorage.setItem(
          "searchDataMerchant",
          JSON.stringify({
            searchBusinessName: props.merchantListData.searchBusinessName,
            searchDbaName: props.merchantListData.searchDbaName,
            searchManagerId: props.merchantListData.searchManagerId,
            searchStatus: props.merchantListData.searchStatus,
            searchManagerName: props.merchantListData.searchManagerName,
          })
        );
        props.history.push(
          `/${props.userDetails.layout}/EditServices?id=${item.ManagerStatus.Business_id}&Manager_id=${item.ManagerStatus.Manager_id}&MerchantSetup=${true}`
        );
      }
    }
  };

  // Function to handle resend invite
  const handleResendInvite = () => {
    setLoading(true);
    props.reSendInviteManagerApiCall(
      {
        Resend_Invite: true,
        Business_OBJid: filteredManager?._id,
        Manager_OBJid: filteredManager?.Manager_Details?._id,
      },
      (res) => {
        setLoading(false);
        setAnchorEl(null);
        if (res.status === true) {
          enqueueSnackbar(`${res.message}`, {
            variant: "success",
          });
        }
      },
      (err) => {
        setLoading(false);
        setAnchorEl(null);
        enqueueSnackbar(`${err.message}`, {
          variant: "error",
        });
      }
    );
  };

  const showApiKey = isVCSAdmin || isPrimaryManager;

  return (
    <div>
      <AppLoader loader={loading} />
      {props.details.Status_Code === 1 || props.details.Status_Code === 2 || props.details.Status_Code === 3 || (props.details.Status_Code === 4 && isVCSAdmin) ? (
        <IconButton
          aria-label="more"
          aria-controls="long-menu"
          style={{ padding: "0px" }}
          aria-haspopup="true"
          onClick={handleClick}
        >
          <MoreVertIcon />
        </IconButton>
      ) : (
        ""
      )}
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
      >
        {isVCSAdmin && (

          <MenuItem
            className={classes.dialogBoxDropDown}
            onClick={() => editServices()}
          >
            Edit Services
          </MenuItem>
        )}
        {props.details.Status_Code === 1 && (
          <MenuItem
            className={classes.dialogBoxDropDown}
            onClick={() => handleResendInvite()}
          >
            Resend Invite
          </MenuItem>
        )}

        {props.details.Status_Code === 3 &&
          menu.Role_Permission_Data.Profile_Code ===
          profileCodePermissionCheck.profileCode.VCS && (
            <MenuItem
              className={classes.dialogBoxDropDown}
              onClick={() => props.handleWebhookModalClick()}
            >
              Webhook Setup
            </MenuItem>
          )}

        {props.details.Status_Code === 3 && (
          <MenuItem
            className={classes.dialogBoxDropDown}
            onClick={() => handleInviteManager()}
          >
            Invite Manager
          </MenuItem>
        )}
        {showApiKey && (
          <MenuItem
            className={classes.dialogBoxDropDown}
            onClick={() => props.handleApiKeyModalClick(props.details)}
          >
            API Key
          </MenuItem>
        )}
      </Menu>
    </div>
  );
}

// Prop types for the MerchantSetupMenu component
MerchantSetupMenu.propTypes = {
  details: PropTypes.object,
  history: PropTypes.any,
  openForm: PropTypes.func,
  setStatusPid: PropTypes.func,
  userDetails: PropTypes.object,
  provider: PropTypes.bool,
  setValues: PropTypes.func,
  sendMailAgain: PropTypes.func,
  roles: PropTypes.object,
  sendInviteApiCall: PropTypes.func,
  sendInviteManagerApiCall: PropTypes.func,
  reSendInviteManagerApiCall: PropTypes.func,
  handleApiKeyModalClick: PropTypes.func,
};

// Mapping Redux state to props
const mapStateToProps = (app) => ({
  formData: app.provideRegistration,
  roles: app.roles,
});

// Connecting the component to Redux
export default connect(mapStateToProps, {
  sendMailAgain,
  sendInviteApiCall,
  sendInviteManagerApiCall,
  reSendInviteManagerApiCall,
})(MerchantSetupMenu);
